import {readGridDensity} from '../shared/components/grid-density-control/grid-density-control.component';
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {RestreamsService}  from "../shared/services/restreams.service";
import {RestreamProject, SrtStatusResponse} from "../shared/interfaces";
import {SrtPointModalComponent} from './srt-point-modal/srt-point-modal.component';
import {outputLimitText} from './srt-reasons';
 
import {Observable, from, Subscription, Subject} from "rxjs";
import { debounceTime, delay, map,filter } from 'rxjs/operators';
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
import {OverviewRestreamsItemComponent} from './overview-restreams-item/overview-restreams-item.component';

import {SocketRestreamsOverview} from "../shared/services/sockets";
 import { NbMenuService } from '@nebular/theme';
  import { GoogleAnalyticsService } from '../@core/utils/analytics.service';


@Component({
  selector: 'app-overview-restreams-page', 
  templateUrl: './overview-restreams-page.component.html',
  styleUrls: ['./overview-restreams-page.component.scss'],
  
})
export class OverviewRestreamsPageComponent implements OnInit, OnDestroy, AfterViewInit{

  // Cards per row, as a ceiling - the grid drops a column by itself rather than
  // squeezing cards below a readable width.
  colsKey: string = 'livestream:restreams:cols'
  cols: number = readGridDensity(this.colsKey)


  
  @ViewChild('deleteModal') deleteModal: any;
       menuSub$:any;

  showControls = false
  fetchLoading = true
  removeLoading = false
  createSub$: Subscription; 
  removeSub$: Subscription;
  restreams: RestreamProject[] = [];
  srtStatus: SrtStatusResponse = null
  srtTimer: any = null
  srtStatusSub$: Subscription
  createMenuSub$: Subscription
  createMenu = [
    {title: 'Ретрансляція в соцмережі', cmd: 'create-restream'},
    {title: 'SRT-точка (вхід / вихід)', cmd: 'create-srt'}
  ]
  settingsModalInstance: any = null
  restreamsWithSignal: number = 0

  streamToDelete: RestreamProject = null
   restreams$: Subscription;
   eventEmitter = new Subject<any>();

  constructor( 
    private restreamService : RestreamsService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private socket: SocketRestreamsOverview,
public gAnalytics: GoogleAnalyticsService,
private nbMenuService: NbMenuService
    ){ 
    //  this.socket.removeAllListeners()
    //  this.socket.disconnect()
    }
   

  ngOnInit() { 
  
    this.restreams$ = this.restreamService.fetch().subscribe((restreams: RestreamProject[])=>{

      let ids = []
        this.restreams = restreams.map(s =>{
          s.isRunning = false 
          return s
        })



      this.socket.on('connect', ()=>{
        this.socket.emit('onJoin', {
          
        })
       
      })
 
      this.socket.on('ReRestreamsDisconnect', this.onRestreamDisconnect.bind(this))
      this.socket.on('ReRestreamsSignal', this.onRestreamSignal.bind(this))
      this.socket.on('ReRestreamsEvent', this.onRestreamEvent.bind(this))
      this.socket.on('ReBitratesEvent', this.onBitratesEvent.bind(this))
      this.socket.on('outputLimitReached', this.onOutputLimitReached.bind(this))

      this.refreshSrtStatus()
      this.srtTimer = setInterval(()=>{
        if(this.restreams.some(r => r.kind === 'srt')){
          this.refreshSrtStatus()
        }
      }, 5000)
      
      this.socket.on('initialRestreamsData', (data)=>{
   
        for(let restr of data){
          let candidate = this.restreams.find(r=>{return r._id === restr.id})
          if(candidate){
          
            candidate.signalInfo = restr.info
            candidate.bitrate = restr.bitrate
            candidate.hasSignal = true
            candidate.runningsCount = restr.runningRestreams.length
            candidate.runningList = restr.runningRestreams

            this.restreamsWithSignal++
          }
        } 
        this.fetchLoading = false
      })
      


      setInterval(()=>{

        if(this.restreamsWithSignal > 0){
          
          this.socket.emit('refreshBitrates')
        }

      },1000)


      //
      
      this.socket.connect()
      
        
      
      },()=>{
      //  this.fetchLoading = false
        this.toastrService.show(``,'Сталася помилка завантаження',{
          status: 'danger',
          position: <NbGlobalPosition>'bottom-end'
        })
      },()=>{ })    

 	if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
		this.menuSub$ =	  this.nbMenuService.onItemClick()
		      .pipe(
 			filter(({ tag }) => tag === 'restream-menu'),
			 map(({ item }) => item)
		      )
		      .subscribe( (item : any) => {this.onMenuClick(item.cmd, item.item);  }); 

    if(this.createMenuSub$){
      this.createMenuSub$.unsubscribe()
    }
    this.createMenuSub$ = this.nbMenuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'restream-create-menu'),
        map(({ item }) => item)
      )
      .subscribe((item: any) => {
        if(item.cmd === 'create-restream'){ this.createRestream() }
        if(item.cmd === 'create-srt'){ this.createSrtPoint() }
      })
  }




   onMenuClick(cmd, restream){ 
	if(cmd === 'remove') { this.streamToDelete = restream; this.openRemoveModal();   return;}



  }



	  openRemoveModal() { 
	  this.dialogService.open(this.deleteModal,{hasScroll: true} )

	  
	}





	removeSelectedRestream(ref){
	  ref.close()
	  this.removeRestream(this.streamToDelete)

	}



    createRestream(){

      this.createSub$ = this.restreamService.create().subscribe((restream: RestreamProject)=>{


        this.toastrService.show(`Ретрансляція "${restream.title}" створена`,'Створення ретрансляції',{
          status: 'success',
          position: <NbGlobalPosition>'bottom-end'
        })

        restream.isRunning = false
          this.restreams.unshift(restream)

		 this.gAnalytics.trackEvent('Add_restream') 
      },()=>{
        this.toastrService.show(``,'Сталася помилка',{
          status: 'danger',
          position: <NbGlobalPosition>'bottom-end'
        })
      })
 
    }



    onBitratesEvent(data){
      for(let restr of data){
        let candidate = this.restreams.find(r=>{return r._id === restr.id})
        if(candidate){
         
          candidate.bitrate = restr.bitrate
        
        }
      } 


    }



    onRestreamEvent(data){
     

       const key = data.payload.restreamKey
      const restream = this.restreams.find(r=>{return r.restreamKey === key})

      if(restream){ 

        if(data.payload.restreamEventType === 'error'){

          let l =  data.payload.runningRestreams.filter(r=>{return r.id !== data.payload.restreamData.id })
          restream.runningList = l
          restream.runningsCount = l.length


        }else{


           restream.runningList = data.payload.runningRestreams
           restream.runningsCount = data.payload.runningRestreams.length
        }
        

        this.eventEmitter.next({type:'updateRunnings'})
        
      }

    }
    


    onRestreamSignal(data){
 
      const key = data.payload.restreamKey
      const restream = this.restreams.find(r=>{return r.restreamKey === key})

      if(restream){

        restream.hasSignal = true

        restream.signalInfo = data.payload.info
        restream.runningsCount = data.payload.runningRestreams.length
        restream.runningList = data.payload.runningRestreams

        this.eventEmitter.next({type:'updateRunnings', connected: true})

        this.restreamsWithSignal++
      }

    }
    onRestreamDisconnect(data){
 
      const key = data.payload.restreamKey
      const restream = this.restreams.find(r=>{return r.restreamKey === key})

      if(restream){

        restream.hasSignal = false
        restream.runningsCount = 0
        restream.runningList = []
        restream.signalInfo = null
	restream.bitrate = 0
        this.eventEmitter.next({type:'updateRunnings', connected: false})
        this.restreamsWithSignal--
      }
    }
  
  
  ngAfterViewInit() {
 
   }
 

  
 

   openRestreamModal(restream){
    if(restream.kind === 'srt'){
      return this.openSrtPointModal(restream)
    }
    this.settingsModalInstance =  this.dialogService.open(OverviewRestreamsItemComponent, {
      dialogClass: 'settings-modalsscrollable-container',
      context: {
        restream: restream,
        socket: this.socket, 
        eventEmitter: this.eventEmitter
      },
    });
  
      
    this.settingsModalInstance.onClose.subscribe(()=>{
       this.settingsModalInstance = null
    })
   }
  



removeRestream(restream: RestreamProject){
  

    if(this.removeSub$){
      this.removeSub$.unsubscribe()
    }

  this.removeLoading = true	

    this.removeSub$ = this.restreamService.delete(restream._id).subscribe(()=>{
      this.streamToDelete = null

    this.toastrService.show(`Ретрансляція "${restream.title}" видалена`,'Видалення ретрансляції',{
      status: 'danger',
  position: <NbGlobalPosition>'bottom-end'
    })
      this.restreams = this.restreams.filter(s => s._id !== restream._id)
    },()=>{
  this.toastrService.show(`Сталася помилка при видаленні`,'Видалення ретрансляції',{
      status: 'danger',
      position: <NbGlobalPosition>'bottom-end'
    })
  this.removeLoading = false  
  },()=>{


    this.removeLoading = false  


  })
}




  refreshSrtStatus(){
    if(this.srtStatusSub$){
      this.srtStatusSub$.unsubscribe()
    }
    this.srtStatusSub$ = this.restreamService.srtStatus().subscribe((status: SrtStatusResponse)=>{
      this.srtStatus = status
      for(let point of status.points){
        const candidate = this.restreams.find(r => r._id === point.id)
        if(candidate){
          candidate.srt = point
        }
      }
      if(this.settingsModalInstance && this.settingsModalInstance.componentRef && this.settingsModalInstance.componentRef.instance instanceof SrtPointModalComponent){
        this.settingsModalInstance.componentRef.instance.status = status
      }
    }, ()=>{})
  }

  createSrtPoint(){
    this.createSub$ = this.restreamService.createSrtPoint().subscribe((point: RestreamProject)=>{
      this.toastrService.show(`SRT-точка "${point.title}" створена`, 'Створення SRT-точки', {
        status: 'success',
        position: <NbGlobalPosition>'bottom-end'
      })
      point.isRunning = false
      this.restreams.unshift(point)
      this.refreshSrtStatus()
    }, (err)=>{
      const notInTariff = err && err.error && err.error.reason === 'srt_not_in_tariff'
      this.toastrService.show(
        notInTariff ? 'SRT-точки доступні з тарифу Professional і вище.' : '',
        notInTariff ? 'SRT-точка недоступна на вашому тарифі' : 'Сталася помилка',
        {status: notInTariff ? 'warning' : 'danger', position: <NbGlobalPosition>'bottom-end', duration: notInTariff ? 8000 : 3000}
      )
    })
  }

  openSrtPointModal(restream: RestreamProject){
    this.settingsModalInstance = this.dialogService.open(SrtPointModalComponent, {
      autoFocus: false,
      context: {
        restream: restream,
        status: this.srtStatus
      },
    })
    this.settingsModalInstance.onClose.subscribe(()=>{
      this.settingsModalInstance = null
      this.refreshSrtStatus()
    })
  }

  onOutputLimitReached(data){
    this.toastrService.show(outputLimitText(data && data.used, data && data.limit), 'Канал не запущено', {
      status: 'warning',
      position: <NbGlobalPosition>'bottom-end',
      duration: 8000
    })
  }

  ngOnDestroy() {
    if(this.srtTimer){
      clearInterval(this.srtTimer)
    }
    if(this.srtStatusSub$){
      this.srtStatusSub$.unsubscribe()
    }
    if(this.createMenuSub$){
      this.createMenuSub$.unsubscribe()
    }
    this.socket.removeAllListeners('outputLimitReached')

   // this.socket.removeAllListeners()
    this.socket.disconnect()


    this.socket.removeAllListeners('connect')
    this.socket.removeAllListeners('ReRestreamsDisconnect')
    this.socket.removeAllListeners('ReRestreamsSignal')
    this.socket.removeAllListeners('ReRestreamsEvent')
    this.socket.removeAllListeners('ReBitratesEvent')
    this.socket.removeAllListeners('initialRestreamsData')
 
   
 if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }

    if(this.restreams$){
      this.restreams$.unsubscribe()
    }

    if(this.removeSub$){
      this.removeSub$.unsubscribe()
    }

  }


}
